// extracted by mini-css-extract-plugin
module.exports = {"red":"ingredient-score-module--red--1X98K","yellow":"ingredient-score-module--yellow--1w1x6","green":"ingredient-score-module--green--dZwaz"};